import { useCallback } from "react";

import {
  RenewalStatus,
  useGetPolicyLazyQuery,
  useRetryRenewalIssuanceMutation,
} from "@covertree/agent-portal-graphql";
import { Toast } from "@covertree/utils";
import { getErrorMessageFromApolloError } from "@utils/getErrorMessageFromApolloError";

export function useRetryRenewalIssuance() {
  const [retryIssuance, { loading }] = useRetryRenewalIssuanceMutation({
    notifyOnNetworkStatusChange: true,
  });

  const [getPolicy] = useGetPolicyLazyQuery();

  const retryIssuanceHandler = useCallback(
    async (renewalLocator: string) => {
      try {
        const { data } = await retryIssuance({
          variables: {
            renewalLocator,
          },
        });
        Toast.showSuccess(
          "Renewal retrial succeeded. Payment processing is in progress. Renewal status should be updated within a minute."
        );
        if (data.retryRenewalIssuance.status === RenewalStatus.PaymentFailed) {
          await getPolicy({
            variables: {
              policyLocator: data.retryRenewalIssuance.policyLocator,
            },
            fetchPolicy: "cache-and-network",
          });
        }
      } catch (error) {
        Toast.showError(
          getErrorMessageFromApolloError(error) ||
            "Renewal operation payment retry failed. Please try again or contact tech team on fuji-san channel."
        );
      }
    },
    [retryIssuance]
  );

  return {
    retryIssuance: retryIssuanceHandler,
    loading,
  };
}
